import { get } from './get'
import { list } from './list'

export default {
  ...get,
  ...list
}
